"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const has = paramName => {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(paramName);
};
const get = paramName => {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(paramName) ? urlParams.get(paramName) : null;
};
const urlParams = {
  get,
  has
};
var _default = exports.default = urlParams;